import { useMutation } from '@tanstack/react-query';
import { Button } from '@givebutter/primitives/button';
import { useToast } from '@givebutter/primitives/toast';
import { faSpinnerThird } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { enableRecurringPayments } from 'api/transactionPlans';
import * as SubNav from 'components/sub-nav';
import { TransactionsSubNavTabs } from 'components/sub-nav/TransactionsSubNavTabs';
import { Settings } from 'constants/settings';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { useInvalidateUserAndAccount } from 'customHooks/useInvalidateUserAndAccount';

const RecurringPaymentsSplash = () => {
    const toast = useToast();
    const { accountId } = useCurrentAccount();
    const { mutate: invalidateUserData } = useInvalidateUserAndAccount();
    const { mutate: enablePayments, isPending: isLoading } = useMutation({
        mutationFn: () => enableRecurringPayments(accountId, Settings.EnableRecurringPayments.Code),
        onSuccess: () => invalidateUserData(),
        onError: () => {
            toast.error('Unable to activate Recurring Plans');
        },
    });

    return (
        <div className={'flex flex-col gap-y-4'}>
            <SubNav.Root>
                <SubNav.Header>
                    <SubNav.Title>Recurring plans</SubNav.Title>
                </SubNav.Header>
                <TransactionsSubNavTabs />
            </SubNav.Root>
            <div className={'flex flex-wrap-reverse items-center justify-center gap-8 py-10'}>
                <div className={'flex flex-1 flex-col gap-y-4'}>
                    <h1 className={'text-3xl font-medium leading-none'}>Recurring Plans</h1>
                    <h2 className={'text-lg font-medium'}>
                        Accept recurring payments using PayPal and credit cards with any fundraising
                        campaign, ticketed event, or website donation form.{' '}
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://givebutter.com/features/recurring-donations"
                        >
                            Learn More
                        </a>
                        .
                    </h2>
                    <Button
                        variant="solid"
                        disabled={isLoading}
                        className={'w-fit'}
                        onClick={() => enablePayments()}
                    >
                        {isLoading ? (
                            <FontAwesomeIcon className="animate-spin" icon={faSpinnerThird} />
                        ) : null}
                        Enable Recurring Plans
                    </Button>
                </div>
                <div className={'flex-1'}>
                    <img
                        className={'m-auto max-w-[250px] md:m-0'}
                        alt="Illustration"
                        src={`/images/illustrations/recurring-payments.svg`}
                    />
                </div>
            </div>
        </div>
    );
};

export { RecurringPaymentsSplash };
